import { WebStorageStateStore } from 'oidc-client'

export const host = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`

export const activePdfSettings = {
  protocol: 'https',
  hostname: 'pdf.workaware.com',
  port: 62626,
  language: 'en',
}

export const apiSettings = {
  workaware: {
    base: process.env.NODE_ENV === 'production'
     ? 'https://rqip9zozib.execute-api.us-east-1.amazonaws.com'
      : 'https://rqip9zozib.execute-api.us-east-1.amazonaws.com',
      //: 'https://970c6mpw30.execute-api.us-east-1.amazonaws.com',
      //: 'https://970c6mpw30.execute-api.us-east-1.amazonaws.com',
    cullIdsInPostRequests: true,
  },
}

export const oidcSettings = {
  client_id: 'workaware-web',
  redirect_uri: `${host}/callback`,
  post_logout_redirect_uri: `${host}/bye`,
  response_type: 'code',
  scope: 'openid',
  authority: apiSettings.workaware.base,
  automaticSilentRenew: false,
  filterProtocolClaims: false,
  loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
}

export const debugSettings = {
  showListenerMessages: false,
}

export const uiSettings = {
  pagination: {
    rowsOptions: [10, 20, 50, 100],
    defaultRows: 10,
  },
  drawerWidth: 280,
  metaDrawerWidth: 300,
  drawerWidthClosed: 55,
  background: 'white',
  header: {
    appBarHeight: 80,
    appBarHeightMobile: 55,
    foreground: 'white',
    background: 'white'
  }
};

export const apiKeys = {
    google: 'AIzaSyCd0Lu53AK-_hfpsOpSOGj3glxEMY5hAo4'
}